import { render, staticRenderFns } from "./card-detail.vue?vue&type=template&id=6f161d2c&scoped=true&"
import script from "./card-detail.vue?vue&type=script&lang=js&"
export * from "./card-detail.vue?vue&type=script&lang=js&"
import style0 from "./card-detail.vue?vue&type=style&index=0&id=6f161d2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._qkvgvrmvpkafkn37suro37nope/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f161d2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_gys_admin_online_docker/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f161d2c')) {
      api.createRecord('6f161d2c', component.options)
    } else {
      api.reload('6f161d2c', component.options)
    }
    module.hot.accept("./card-detail.vue?vue&type=template&id=6f161d2c&scoped=true&", function () {
      api.rerender('6f161d2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nb/order/refund/components/card-detail.vue"
export default component.exports